import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import Avatar from '@material-ui/core/Avatar';
import { logout } from 'redux/actions/userActions';
import { withStyles } from '@material-ui/core/styles';
import { secondary300 } from 'themes/colors';
import Menu from 'components/Menu/Menu';
import { MIN_DESKTOP_WIDTH } from 'constants/misc';
import ProfileMenuItems from 'components/ProfileMenuItems';
import { OPEN_PROFILE_MENU } from 'constants/analytics';
import { withRouter } from 'react-router';
import { analyticsTrack } from '../../utils/analytics';


const styles = $theme => ({
  profileWrapper: {
    cursor: 'pointer',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '2rem',
    [`@media screen and (max-width: ${MIN_DESKTOP_WIDTH}px)`]: {
      display: 'none',
    },
  },
  dropdownContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarRoot: {
    width: '2rem',
    height: '2rem',
    marginRight: '0.625rem',
    backgroundColor: $theme.palette.primary.main,
  },
  chevronRoot: {
    color: secondary300,
  },
});


class Profile extends PureComponent {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    user: PropTypes.shape({
      first_name: PropTypes.string,
    }).isRequired,
    classes: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  handleProfileClick = (event) => {
    analyticsTrack(OPEN_PROFILE_MENU, {
      open: true,
    }, true);
    this.setState({ anchorEl: event.currentTarget });
  }

  handleProfileClose = () => {
    analyticsTrack(OPEN_PROFILE_MENU, {
      open: false,
    }, true);
    this.setState({ anchorEl: null });
  }

  handleChatWithUs = () => {
    if (window.Intercom) window.Intercom('showNewMessage');
    this.setState({ anchorEl: null });
  };

  handleLogout = () => {
    this.props.logout();
  };

  handleMyAccount = () => {
    this.setState({ anchorEl: null });
    this.props.history.push('/myaccount');
  }

  render() {
    const { classes, user } = this.props;
    const { anchorEl } = this.state;
    return (
      <div className={classes.profileWrapper}>
        <div
          className={classes.dropdownContainer}
          role="button"
          tabIndex="-1"
          onKeyDown={() => {}}
          onClick={this.handleProfileClick}
        >
          <Avatar classes={{ root: classes.avatarRoot }}>{user.first_name.charAt(0)}</Avatar>
          <KeyboardArrowDownRoundedIcon classes={{ root: classes.chevronRoot }} />
        </div>
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.handleProfileClose}
        >
          <ProfileMenuItems
            handleLogout={this.handleLogout}
            handleMyAccount={this.handleMyAccount}
            handleChatWithUs={this.handleChatWithUs}
          />
        </Menu>
      </div>
    );
  }
}

export default compose(
  withRouter,
  withStyles(styles, { withTheme: true }),
  connect(state => ({
    user: state.user,
  }), { logout }),
)(Profile);
